import { 
    postData, 
    getDataWithParams,
    destroyData,
} from '@/store/api/method-mbkm'

const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
    semesterId: null,
}
const itemInit = {
    id: null,
    semester_id: null,
    study_course_name: null,
    study_program_name: null,
    lecture_name: null,
    type: null,
}

const mahasiswaInit = {
    id: null,
    oad_id: null,
    study_course_id: null,
    semester_id: null,
    user_id: 0,
    nama_mahasiswa: null,
    npm: null,
    jumlah: 0,
    jumlah1: null,
    type: null,
    page: 1,
    show: 10,
}

const absenInit = {
    id: null,
    oad_id: null,
    logDate: null,
    logValue: null,
    registration_id: null,
    status: 0,
    rejectedNote: null,
    type: null,
    // url: null,
    // payload: null,
}

const initialState = () => ({
    msg: null,
    data: {},
    dataMahasiswa: {},
    dataAbsen: {},
    list: [],
    sc_info: null,
    nama_user_info: null,
    username_info: null,
    lecture_info: null,
    request: {...requestInit},
    item: {...itemInit},
    itemMahasiswa: {...mahasiswaInit},
    itemAbsen: {...absenInit},
    statusConfirmation: [
        {
            status: 0,
            label: 'Belum dikonfirmasi',
            type: 'primary'
        },
        {
            status: 1,
            label: 'Dikonfirmasi',
            type: 'success'
        },
        {
            status: 91,
            label: 'Ditolak',
            type: 'danger'
        }
    ]
})
const state = initialState
 
const getters = {
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getData: state => state.data || {},
    getDataMahasiswa: state => state.dataMahasiswa || {},
    getDataAbsen: state => state.dataAbsen || {},
    getRequest: state => state.request,
    getItem: state => state.item,
    getStatusConfirmation: state => (status) => state.statusConfirmation.find(x => x.status == status),
    getStudyCourseNameInfo: state => state.sc_info,
    getNamaUserInfo: state => state.nama_user_info,
    getNPMInfo: state => state.username_info,
    getLectureId: state => state.lecture_info,
    getItemMahasiswa: state => state.itemMahasiswa,
    getItemAbsen: state => state.itemAbsen
}

const actions = {
    resetRequest({commit}){
        commit('SET_REQUEST',{...requestInit})
    },
    resetItem({commit}){
        commit('SET_ITEM',{...itemInit})
    },
    resetItemMahasiswa({commit}){
        commit('SET_ITEM_MAHASISWA',{...mahasiswaInit})
    },
    resetItemAbsen({commit}){
        commit('SET_ITEM_ABSEN',{...absenInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    setItemMahasiswa({commit}, value){
        commit('SET_ITEM_MAHASISWA',{...value})
    },
    setItemAbsen({commit}, value){
        commit('SET_ITEM_ABSEN',{...value})
    },
    async store({commit}, data) {
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/attendance/store',payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchDataOprec({commit, state}){
        try {
            const response = await getDataWithParams('/attendance/list-oprec',state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    // async fetchDataMahasiswa({commit, state}, study_course_id, semester_id){
    //     try {
    //         const response = await getDataWithParams('/attendance/'+study_course_id+'/'+semester_id,state.request);
    //         // const response = await getDataWithParams('/attendance/'+study_course_id+'/'+semester_id,state.request);
    //         commit('SET_RESPONSE', response.data);
    //         commit('SET_DATA_LIST_MAHASISWA', response.data.data);
    //     } catch (err) {
    //         if(err.response){
    //             commit('SET_FAILED_MESSAGE', err.response);
    //         }else{
    //             commit('SET_FAILED')
    //         }
    //     }
    // },
    async fetchDataMahasiswa({commit}, data) {
        try {
            const url = `/attendance/list-mahasiswa/${data.study_course_id}/${data.semester_id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA_LIST_MAHASISWA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchDataIsiAbsen({commit, state}, registrationId){
        try {
            const response = await getDataWithParams('/attendance/list-result/'+registrationId,state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA_ISI_ABSEN', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({commit}, data) {
        try {
            const url = `/attendance/update/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async updateStatus({commit}, data) {
        try {
            const url = `/attendance/update-status/${data.id}/${data.semester_id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async verify({commit}, data) {
        try {
            const url = `/attendance/verify/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    
    async destroy({commit}, data) {
        try {
            const url = `/attendance/${data.id}`
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        state.msg = error?.data?.msg || 'Jaringan Bermasalah'
        state.status = error?.data?.status || 0
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_DATA_LIST_MAHASISWA(state, response){
        state.dataMahasiswa = response.data
        state.sc_info = response.study_course_name
    },
    SET_DATA_ISI_ABSEN(state, response){
        state.dataAbsen = response.data
        state.sc_info = response.study_course_name
        state.nama_user_info = response.nama_user
        state.username_info = response.username
        state.lecture_info = response.lecture

    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    SET_ITEM_MAHASISWA(state, value){
        state.itemMahasiswa = value
    },
    SET_ITEM_ABSEN(state, value){
        state.itemAbsen = value
    },
    SET_LIST(state, value){
        state.list = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
